var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsArray, IsDateString, IsNumber } from "class-validator";
import { safeAssign } from "./safe-assign";
export class GetRosterCostsParams {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetRosterCostsParams.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetRosterCostsParams.prototype, "to", void 0);
__decorate([
    Expose(),
    IsArray(),
    __metadata("design:type", Array)
], GetRosterCostsParams.prototype, "filters", void 0);
export class RosterDailyCostDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], RosterDailyCostDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], RosterDailyCostDTO.prototype, "planned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], RosterDailyCostDTO.prototype, "final", void 0);
export class RosterCostsDTO {
    constructor(vals) {
        safeAssign(this, vals);
    }
}
__decorate([
    Expose(),
    Type(() => RosterDailyCostDTO),
    __metadata("design:type", Array)
], RosterCostsDTO.prototype, "days", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], RosterCostsDTO.prototype, "totalPlanned", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], RosterCostsDTO.prototype, "totalFinal", void 0);
//# sourceMappingURL=roster-costs.dto.js.map